import { render, staticRenderFns } from "./MessageMultiselect.vue?vue&type=template&id=0b30f5f2&"
import script from "./MessageMultiselect.vue?vue&type=script&lang=js&"
export * from "./MessageMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports